import CancelTable from 'components/gifts-table/Cells/CancelTable';
import {
  CellRendererGray,
  CellRendererRed,
} from 'components/gifts-table/TableList';

export const columns = [
  {
    label: { tipo: 'TIPO', evento: ' EVENTO' },
    //renderer: (item) => CellRendererGray(item.fecha, item.evento),
    renderer: (item) => CellRendererGray(item.tipo, item.evento),
  },
  {
    label: { nombre: 'NOMBRE' },
   // renderer: (item) => CellRendererRed(item.tipo, item.nombre),
   renderer: (item) => CellRendererRed(item.festejados),
  },
  {
    label: { fecha: 'FECHA' },
   // renderer: (item) => CellRendererRed(item.tipo, item.nombre),
   renderer: (item) => CellRendererRed(item.fecha),
  },
  {
    label: 'ESTATUS',
    field: 'estatus',
    onClickDelete: true,
    renderer: (props) => <CancelTable {...props} />,
  },
];
